import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import styles from './InactiveStateCard.module.css';

export function InactiveStateCard() {
  const navigate = useNavigate();

  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      </div>

      <h3 className={styles.title}>Время вернуться к защите</h3>
      <p className={styles.subtitle}>
        Активных VPN-ключей нет. Оформите подписку, чтобы продолжить безопасный доступ к интернету.
      </p>

      <div className={styles.actions}>
        <Button onClick={() => navigate('/dashboard/plans')} fullWidth>
          Оформить подписку
        </Button>
      </div>
    </div>
  );
}
